import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): the Gantt ships behind the `gantt` feature flag until released. */
export async function requireGanttFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.gantt || !flags.tasks) throw notFound();
}
